import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as FacebookIcon } from "../../assets/Icons/facebook.svg";
import { ReactComponent as TwitterIcon } from "../../assets/Icons/twitter.svg";
import { ReactComponent as Closeicon } from "../../assets/Icons/closeFilled.svg";
import { ReactComponent as AddRatings } from "../../assets/Icons/starRounded.svg";
import { ReactComponent as StarIcon } from "../../assets/Icons/star.svg";
import { ReactComponent as Close } from "../../assets/Icons/icons8-close.svg";
import { ReactComponent as StartOverIcon } from "../../assets/Icons/start-over.svg";
import { ReactComponent as AddToListIcon } from "../../assets/Icons/addToList.svg";
import { ReactComponent as RemoveFromListIcon } from "../../assets/Icons/removeFromList.svg";
import { ReactComponent as AddToListIcon2 } from "../../assets/Icons/addToList2.svg";
import { ReactComponent as RemoveFromListIcon2 } from "../../assets/Icons/removeFromList2.svg";
import { ReactComponent as RefreshIcon } from "../../assets/Icons/refresh.svg";
import * as service from "./service";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import "react-toastify/dist/ReactToastify.css";
import { getPlayerToken, getUserSubscription, updateWatchlistData } from "../../network/service";
import VideoJS from "../../Components/VideoJsPlayer/VideoJS";
import ShowsRow from "../../Components/ShowsRow/ShowsRow";
import GaiaShowsRow from "../../Components/ShowsRow/GaiaShowsRow";
import { toast } from "react-toastify";
import { imageUrlCheck, onVideoPlayFunction } from "../../utils/utils";
import Loading from "../../Components/Loading/Loading";
import useScrollPosition from "../../Components/ScrollPosition/useScrollPosition";
import './scss/detailScreen.css';
import { stripeSession } from "../Subscription/service";
import TrailerModal from "../../Components/Modals/TrailerModal";
import RatingsAndReviewModal from "../../Components/Modals/RatingAndReviewModal";
import Translate, { useTranslateText } from "../../Components/Multilanguage/Translate";
import LockIcon from "../../assets/Images/lock.png";
import { ReactComponent as ChevronDown } from "../../assets/Icons/chevron-down.svg";
import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import AboutSection from "./Components/AboutSection";
import AwardsAndFestivals from "./Components/AwardsAndFestivals";
import CastAndCrew from "./Components/CastAndCrew";
import CategoriesSection from "./Components/CategoriesSection";
import Util from "./util";
import { isHTML } from "../../utils/utils";

let debounce = true;
var videoStarted = false;
let seconds = 60;
let prevTime;
let videoPlaying = false;
Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};
const DetailsScreen = () => {

  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const isDocPlus = projectInfo?.projectConfig?.pubid === 50158;
  const godtv = projectInfo?.projectConfig?.pubid === 50174;
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const userSubscriptionData = useSelector((state) => state?.userSubscription?.value);
  const [isShareActive, setIsShareActive] = useState(false);
  const [isReport, setIsReport] = useState(false);
  const [videoPlay, setVideoPlay] = useState(false);
  const [watchDuration, setWatchDuration] = useState("");
  const [pageURL, setPageURL] = useState(0);
  const [showDetails, setShowDetails] = useState({});
  const [similarVideos, setSimilarVideos] = useState([]);
  const [playerToken, setPlayerToken] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [videoPlayer, setVideoPlayer] = useState("");
  const [watchlistStatus, setWatchlistStatus] = useState();
  const [selectedVideoDetails, setSelectedVideoDetails] = useState();
  const [logoutModal, setLogoutModal] = useState(false);
  const [categories, setCategories] = useState("");
  const [trailerPlaying, setTrailerPlaying] = useState(true);
  const [modalType, setModalType] = useState({ type: "logoutAll" });
  const [adUrl, setAdUrl] = useState("");
  const [initialVideoSubscriptions, setInitialVideoSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [skeleton, setSkeleton] = useState(false);
  const [subscribedUser, setSubscribeduser] = useState(false);
  const [browserPipMode, setBrowserPipMode] = useState(false);
  const [pipMode, setPipMode] = useState(false);
  const [nowPlaying, setNowPlaying] = useState("");
  const [episodes, setEpisodes] = useState();
  const [showAllEpisodes, setShowAllEpisodes] = useState(false);
  const [episodesColumns, setEpisodesColumns] = useState(10);
  const [nextEpisodeModal, setNextEpisodeModal] = useState(false);
  const [isFreeVideo, setIsFreeVideo] = useState(false); // for inital free video checking for showing button name "subscribe" ,"watchNow" or "watch for free"
  const [thumbnailOrientation, setThumbnailOrientation] = useState("");
  const [subscribeButton, setSubscribeButton] = useState();
  const [subtitleInfo, setSubTitleInfo] = useState();
  const [countinueWatchingVideoPlayedStatus, setCountinueWatchingVideoPlayedStatus] = useState(false);
  const [isTrailer, setIsTrailer] = useState(false)
  const [ratingReviewModal, setRatingReviewModal] = useState(false);
  const [userRatedCount, setUserRatedValue] = useState();
  const [refetchTrigger, setRefetchTrigger] = useState(null);
  const position = useScrollPosition();
  const location = useLocation();
  const [showId, setShowId] = useState();
  const type = location?.state?.type;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const translateText = useTranslateText();
  const [videoType, setVideoType] = useState("video")

  let shareRef = useRef(null);
  let reportRef = useRef(null);
  let shareIconRef = useRef(null);
  let shareTwoRef = useRef(null);
  let reportTwoRef = useRef(null);
  let shareIconTwoRef = useRef(null);
  let scrollDownRef = useRef(null);
  let episodeCount = 0;
  let isLive = false
  const buttonTextColor = projectInfo?.projectConfig?.config?.BUTTON_TEXT_COLOR;
  const textColor = projectInfo?.projectConfig?.config?.TEXT_COLOR;
  const theme = projectInfo?.projectConfig?.config?.THEME;
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    sessionId,
  };
  const playerRef = useRef(null);
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const kids = template === 'TEMPLATE_12';
  const [visibleSection, setVisibleSection] = useState("episodes");
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);

  useEffect(() => {
    const threshold = kids ? 980 : 768;
    setIsMobile(window.innerWidth <= threshold);
    const handleKidsMobile = () => setIsMobile(window.innerWidth <= threshold);
    window.addEventListener('resize', handleKidsMobile);
    return () => window.removeEventListener('resize', handleKidsMobile);
  }, [kids]);

  const {
    fetchShowDetails,
    fetchShowDetailsByVanityUrl,
    fetchSimilarVideos,
    fetchPlayerToken,
    addToWatchlist,
    removeFromWatchlist,
    subscriptionCheck,
    handleSubscribe,
    watchVideoHandler,
    handleStartOver,
    handleWatchNowClick,
    // handlePlayerReady,
    updateVideoAnalytics,
    findIndex,
    fetchUserSubscriptionDetails,
    leaveChallengeHandler,
  } = Util();

  useEffect(() => {
    localStorage.removeItem("couponId");
  }, []);

  useEffect(() => {
    setTrailerPlaying(true);
  }, [location?.pathname]);

  useEffect(() => {
    setPageURL(window.location.href);
    fetchUserSubscriptionDetails(appInfo, dispatch);
  }, []);

  useEffect(() => {
    if (location?.state?.thumbnailOrientation === "PORTRAIT" ||
      (!location?.state?.thumbnailOrientation && projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT")) {
      setThumbnailOrientation("PORTRAIT");
    } else {
      setThumbnailOrientation("LANDSCAPE");
    }
  }, [projectInfo]);

  useEffect(() => {
    localStorage.removeItem("couponId");
  }, []);
  useEffect(() => {
    setAdUrl(null);
    if (showDetails) {
      if (Object.entries(showDetails).length > 0) {
        if (showDetails?.user_rated === true) {
          setUserRatedValue(showDetails?.user_rating);
        }
        else {
          setUserRatedValue(null);
        }
        if (showDetails?.type === "linear_event") {
          setVideoType("event");
        } else {
          setVideoType("video");
        }
        if (showDetails?.categories) {
          let categoryNames;
          showDetails?.categories?.map((item) => {
            categoryNames = categoryNames ? categoryNames + item?.category_name + "," : item?.category_name + ",";
          });
          setCategories(categoryNames);
        }
        if (showDetails?.watchlist_flag === 1) {
          setWatchlistStatus("added");
        } else {
          setWatchlistStatus("removed");
        }
        if (type === "CONTINUE_WATCHING" && countinueWatchingVideoPlayedStatus === false) {
          if (showDetails?.single_video === 0) {
            if (showDetails?.videos && showDetails?.videos[0]?.videos) {
              setEpisodes(showDetails?.videos[0]?.videos);

              let filteredVideo = showDetails?.videos.map((item) => {
                return item?.videos?.filter((videoItem) => videoItem?.video_id === location?.state?.videoId);
              });
              setSelectedVideoDetails(filteredVideo[0][0]);

            } else {
              setEpisodes(showDetails?.videos);

              let filteredVideo = showDetails?.videos?.filter((item) => item?.video_id === location?.state?.videoId);
              setSelectedVideoDetails(filteredVideo[0]);

            }
          } else if (showDetails?.single_video === 1) {
            setEpisodes(null);
            if (showDetails?.videos?.length > 0) {
              setSelectedVideoDetails(showDetails?.videos[0]);

            }
          }
        } else {
          if (showDetails?.teaser_flag === 1 && showDetails?.single_video !== 3) {
            let trailer = true;
            let arr = showDetails?.teaser?.split("/").reverse();
            fetchPlayerToken(
              trailer,
              arr[1],
              appInfo,
              setPlayerToken,
              setVideoUrl,
              showDetails,
              projectInfo
            );
            setNowPlaying("Trailer");
          }
          if (showDetails?.single_video === 1) {
            setSelectedVideoDetails(showDetails?.videos && showDetails?.videos[0]);
            setEpisodes(null);
          } else {
            if (showDetails?.videos && showDetails?.videos[0]?.videos && showDetails?.videos[0]?.videos[0]) {
              setSelectedVideoDetails(showDetails?.videos[0]?.videos[0]);
              setEpisodes(showDetails?.videos[0]?.videos);
            } else {
              setSelectedVideoDetails(showDetails?.videos && showDetails?.videos[0]);
              setEpisodes(showDetails?.videos);
            }
          }
        }
      }
    }
  }, [showDetails, type]);

  useEffect(() => {
    if (position === 0) {
      setPipMode(true);
    }
  }, [position]);

  useEffect(() => {
    window.scroll(0, 0);
    // if (accessToken && Object.keys(projectInfo).length > 0) {

    if (location?.pathname) {
      let vanityUrl = location?.pathname.split("/")[2];
      if (vanityUrl !== "null" && vanityUrl !== "undefined" && vanityUrl) {
        fetchShowDetailsByVanityUrl(
          vanityUrl,
          appInfo,
          setLoading,
          setShowDetails,
          setShowId,
          setSimilarVideos,
          showId
        );
      } else {
        fetchShowDetails(setLoading, setShowDetails, appInfo, showId);
      }

      if (showId) {
        fetchSimilarVideos(null, appInfo, setSimilarVideos, showId);
      }
    }
    // }
  }, [accessToken, projectInfo, location?.pathname]);

  useEffect(() => {
    if (refetchTrigger && location?.pathname) {
      let vanityUrl = location?.pathname.split("/")[2];
      if (vanityUrl !== "null" && vanityUrl !== "undefined" && vanityUrl) {
        fetchShowDetailsByVanityUrl(
          vanityUrl,
          appInfo,
          () => { },
          setShowDetails,
          setShowId,
          setSimilarVideos,
          showId
        );
      } else {
        fetchShowDetails(() => { }, setShowDetails, appInfo, showId);
      }
    }
  }, [refetchTrigger]);

  useEffect(() => {
    if (selectedVideoDetails) {

      if (Object.entries(selectedVideoDetails).length > 0) {
        if (projectInfo?.projectConfig?.config?.REGISTRATION_MANDATORY === "true") {
          setInitialVideoSubscriptions(selectedVideoDetails?.subscriptions);
          if (projectInfo?.projectConfig?.config?.SUBSCRIPTION_REQUIRED === "true") {

            if (selectedVideoDetails?.subscriptions?.length > 0 || showDetails?.subscriptions?.length > 0) {

              let isSubscribedUser;
              if (showDetails?.subscriptions?.length > 0) {
                isSubscribedUser =
                  userSubscriptionData?.data?.length > 0
                    ? subscriptionCheck(userSubscriptionData?.data, showDetails?.subscriptions)
                    : false;
              } else {
                isSubscribedUser =
                  userSubscriptionData?.data?.length > 0
                    ? subscriptionCheck(userSubscriptionData?.data, selectedVideoDetails?.subscriptions)
                    : false;
              }

              if (isSubscribedUser === true) {
                setSubscribeduser(true);
                setSubscribeButton(false);
              } else {
                setSubscribeduser(false);

                if (selectedVideoDetails?.free_video === true) {

                  // for inital free video checking for showing button name "subscribe" ,"play Now"
                  setSubscribeButton(false);

                  setIsFreeVideo(true);
                } else {
                  setSubscribeButton(true);

                  setIsFreeVideo(false);
                }
              }
            } else {
              // setIsFreeVideo(true);
              setSubscribeduser(true);
              setSubscribeButton(false);
            }
          } else {
            setSubscribeduser(true);
            setSubscribeButton(false);
          }
        } else if (projectInfo?.projectConfig?.config?.REGISTRATION_MANDATORY === "false") {
          setSubscribeButton(false);
          if (userSubscriptionData?.login_needed === false) {
            setIsFreeVideo(true);
          } else {
            setIsFreeVideo(false);
          }
          setInitialVideoSubscriptions(selectedVideoDetails?.subscriptions);
        }

        if (showDetails) {
          var updateDuration = selectedVideoDetails?.watched_duration;
          setWatchDuration(updateDuration);
        }
      }
    }
  }, [selectedVideoDetails]);

  useEffect(() => {
    // setVideoUrl("");
    // setPlayerToken("");
    setVideoPlayer(null);
    // setTrailerPlaying(false);
    // videoStarted = false;
    // videoPlaying = false;
  }, [showDetails]);

  useEffect(() => {
    setVideoPlayer(null);
    if (videoUrl) {
      const videoJsOptions = {
        autoplay: videoPlay,
        controls: true,
        responsive: true,
        fluid: true,
        controlBar: {
          pictureInPictureToggle: false,
        },
        sources: [
          {
            src: `${videoUrl}`,
            type: "application/x-mpegURL",
          },
        ],

        // poster:require("../../../images/thumb.png")
      };
      setLoading(false);

      setSkeleton(false);
      setVideoPlayer(
        <VideoJS
          autoplay={true}
          options={videoJsOptions}
          onReady={handlePlayerReady}
          adUrl={adUrl ? adUrl : null}
          subtitles={subtitleInfo}
          isTrailer={true}
        />
      );
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [videoUrl]);

  useEffect(() => {
    setPageURL(window.location.href);
  }, [showDetails]);

  useEffect(() => {
    let handleOutClick = (e) => {
      if (
        !shareIconRef?.current?.contains(e.target) &&
        !shareRef?.current?.contains(e.target) &&
        !shareIconTwoRef?.current?.contains(e.target) &&
        !shareTwoRef?.current?.contains(e.target)
      ) {
        setIsShareActive(false);
      }
      if (!reportRef?.current?.contains(e.target) && !reportTwoRef?.current?.contains(e.target)) {
        setIsReport(false);
      }
    };
    window.addEventListener("click", handleOutClick);
  }, [shareRef, reportRef, shareTwoRef, reportTwoRef]);

  useEffect(() => {
    const updateColumns = () => {
      const w = window.innerWidth;
      if (w <= 480) setEpisodesColumns(2);
      else if (w <= 768) setEpisodesColumns(4);
      else if (w <= 1024) setEpisodesColumns(6);
      else if (w <= 1366) setEpisodesColumns(8);
      else setEpisodesColumns(10);
    };

    updateColumns();
    window.addEventListener('resize', updateColumns);
    const handleMobile = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleMobile);
    return () => window.removeEventListener('resize', updateColumns);
  }, []);

  const handlePlayerReady = (player) => {
    playerRef.current = player;
    if (!trailerPlaying) {
      player.on("play", () => {
        let event = videoStarted === true ? "POP09" : "POP02";
        videoStarted = true;
        videoPlaying = true;
        updateVideoAnalytics(event, player.currentTime(), appInfo, selectedVideoDetails, categories, showDetails);
      });
      player.on("loadedmetadata", () => {
        player.pause();
        if (watchDuration > 0) {
          player.currentTime(watchDuration.toString());
          player.play();
          videoPlaying = true;
        } else {
          player.play();
          videoPlaying = true;
        }
      });
      player.on("timeupdate", function (e) {
        let event = "POP03";
        videoPlaying = true;
        var hasPlayedTime = player.currentTime();
        var intPlayedTime = parseInt(hasPlayedTime, 10);
        var isSixty = intPlayedTime % seconds === 0 && intPlayedTime !== 0;
        if (isSixty && debounce) {
          debounce = false;
          prevTime = intPlayedTime;
          updateVideoAnalytics(event, player.currentTime(), appInfo, selectedVideoDetails, categories, showDetails);
        } else {
          if (debounce == false && prevTime != intPlayedTime) {
            debounce = true;
          }
        }
      });

      player.on("pause", () => {
        let event = "POP04";
        videoPlaying = true;
        updateVideoAnalytics(event, player.currentTime(), appInfo, selectedVideoDetails, categories, showDetails);
      });
      player.on("ended", () => {
        let event = "POP05";
        videoPlaying = false;
        episodeCount = findIndex(episodes, selectedVideoDetails) + 1;

        updateVideoAnalytics(event, player.currentTime(), appInfo, selectedVideoDetails, categories, showDetails);
        if (episodes[episodeCount]) {
          setNextEpisodeModal(true);
        }
      });
      player.on("dispose", () => {
        videoPlaying = false;
        videoStarted = false;
        player.pause();
      });
    } else {
      player.on("timeupdate", () => {
        videoPlaying = true;
      });
      player.on("dispose", () => {
        videoPlaying = false;
      });
    }
  };

  window.addEventListener("enterpictureinpicture", () => {
    setBrowserPipMode(true);
  });

  window.addEventListener("leavepictureinpicture", () => {
    setBrowserPipMode(false);
  });

  const searchHandler = (value, type) => {
    navigate(`/search?query=${value}`, { state: { type } });
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <div className={`detailsScreen ${kids ? 'kids' : ''}`} role="main" aria-label="Show Details Page">
      {isTrailer && (
        <TrailerModal
          appInfo={appInfo}
          teaser={showDetails?.teaser}
          showName={showDetails?.show_name}
          setIsTrailer={setIsTrailer}
          showDetails={showDetails}
        />
      )}
      {ratingReviewModal && user !== "null" && (
        <RatingsAndReviewModal
          showName={showDetails?.show_name}
          director={showDetails?.director}
          year={showDetails?.year}
          showId={showDetails?.show_id}
          setRatingReviewModal={setRatingReviewModal}
          setUserRatedValue={setUserRatedValue}
        />
      )}
      <div className={`wrapper ${kids ? 'kids' : ''}`} role="region" aria-label="Show Details Wrapper">
        <div
          className="bgImageContainer"
          style={{
            top: (template === "TEMPLATE_9" || template === "TEMPLATE_12") ? "100px" : "0",
          }}
          role="img"
          aria-label="Show background image"
        >
          {imageUrlCheck(showDetails?.hero_image || showDetails?.logo_thumb) ? (
            <img src={`${showDetails?.hero_image || showDetails?.logo_thumb}`} alt="Background" />
          ) : (
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}${showDetails?.hero_image || showDetails?.logo_thumb}`}
              alt="Background"
            />
          )}
          {/* {projectInfo?.projectConfig?.config?.BACKGROUND_COLOR && ( */}
          <div
            className={`gradient ${theme === "LIGHT"
              ? "light"
              : "dark"
              }`}
          ></div>
          {/* )} */}
          <div className="gradient"></div>
        </div>
        {videoPlayer && template !== "TEMPLATE_9" && template !== "TEMPLATE_12" && (
          <div
            className={
              pipMode === false
                ? "videoContainer"
                : position > 700 &&
                  browserPipMode === false &&
                  videoPlaying === true
                  ? "videoContainer heightIncrease"
                  : "videoContainer"
            }
          >
            {trailerPlaying && (
              <div className="hideTrailer">
                <button
                  style={{
                    padding: "10px 6px",
                    fontSize: "16px",
                    borderRadius: "8px 0 0 8px",
                    border: "none",
                    background: "rgb(95 93 93)",
                    color: "#fff",
                    cursor: "pointer",
                    opacity: 0.9,
                  }}
                  onClick={() => {
                    const scrollToElement = (element, duration = 1200) => {
                      if (!element) return;
                      const start = window.pageYOffset;
                      const end = element.getBoundingClientRect().top + window.pageYOffset;
                      const change = end - start;
                      let currentTime = 0;
                      const increment = 20;

                      function animateScroll() {
                        currentTime += increment;
                        const val = Math.easeInOutQuad(currentTime, start, change, duration);
                        window.scrollTo(0, val);
                        if (currentTime < duration) {
                          window.requestAnimationFrame(animateScroll);
                        }
                      }
                      animateScroll();
                    };

                    setTrailerPlaying(false);
                    setVideoPlayer(false);

                    setTimeout(() => {
                      const detailsEl = document.querySelector('.details.details-Container');
                      if (detailsEl) {
                        scrollToElement(detailsEl, 1200);
                      }
                    }, 100);
                  }}
                >
                  <Close />
                </button>
              </div>
            )}
            <div
              className={
                position > 700 &&
                  browserPipMode === false &&
                  videoPlaying === true &&
                  pipMode === true
                  ? "player pipMode"
                  : "player"
              }
            >
              <div className="gradientTop"></div>
              <div className="closeIcon" onClick={() => setPipMode(false)}>
                <Closeicon />
              </div>

              <div className="nowPlaying">
                <h1><Translate textKey={'now_playing'} /> : {nowPlaying}</h1>
              </div>

              {videoPlayer && videoPlayer}
            </div>
          </div>
        )}
        {kids && (
          <div className="kidsMobileBanner">
            {imageUrlCheck(showDetails?.hero_image || showDetails?.logo_thumb) ? (
              <img src={showDetails?.hero_image || showDetails?.logo_thumb} alt="Show Banner" />
            ) : (
              <img src={`${process.env.REACT_APP_IMAGE_URL}${showDetails?.hero_image || showDetails?.logo_thumb}`} alt="Show Banner" />
            )}
          </div>
        )}
        <div className="details details-Container" role="region" aria-label="Show Details Section">
          <div className="leftContainer" role="region" aria-label="Show Main Info">
            <div className="showCardDetails">
              <div className="imageContainer">
                {imageUrlCheck(
                  (kids || thumbnailOrientation === "PORTRAIT")
                    ? showDetails?.logo
                      ? showDetails?.logo
                      : projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE
                    : showDetails?.logo_thumb
                      ? showDetails?.logo_thumb
                      : projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE
                ) ? (
                  <img
                    src={
                      (kids || thumbnailOrientation === "PORTRAIT")
                        ? `${showDetails?.logo ||
                        projectInfo?.projectConfig?.config
                          ?.PLACEHOLDER_IMAGE
                        }`
                        : `${showDetails?.logo_thumb ||
                        projectInfo?.projectConfig?.config
                          ?.PLACEHOLDER_IMAGE
                        }`
                    }
                    alt="Background"
                  />
                ) : (
                  <img
                    src={
                      (kids || thumbnailOrientation === "PORTRAIT")
                        ? `${process.env.REACT_APP_IMAGE_URL}${showDetails?.logo ||
                        projectInfo?.projectConfig?.config
                          ?.PLACEHOLDER_IMAGE
                        }`
                        : `${process.env.REACT_APP_IMAGE_URL}${showDetails?.logo_thumb ||
                        projectInfo?.projectConfig?.config
                          ?.PLACEHOLDER_IMAGE
                        }`
                    }
                    alt="Background"
                  />
                )}
              </div>
              {!showDetails?.hide_play_button && (
                <>
                  {!isDocPlus && <div
                    className="watchNow"
                    role="button"
                    tabIndex={0}
                    aria-label="Watch Now"
                    onClick={() =>
                      handleWatchNowClick(
                        selectedVideoDetails,
                        showId,
                        setSelectedVideoDetails,
                        showDetails,
                        categories,
                        thumbnailOrientation,
                        appInfo,
                        user,
                        setRefetchTrigger
                      )
                    }
                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleWatchNowClick(selectedVideoDetails, showId, setSelectedVideoDetails, showDetails, categories, thumbnailOrientation, appInfo, user, setRefetchTrigger); } }}
                  >
                    {/* <button>
                  {
                    subscribeButton && !isFreeVideo ? "Subscribe" :
                      !subscribeButton && isFreeVideo ? "Watch Now" :
                        subscribeButton && isFreeVideo ? "Watch now for free with Ads" :
                          "Watch Now"
                  }
                </button> */}

                    <button
                      style={{
                        color:
                          theme === "LIGHT"
                            ? "white"
                            : (template === "TEMPLATE_9" || template === "TEMPLATE_12")
                              ? buttonTextColor
                              : textColor,
                      }}
                    >
                      {showDetails?.button_text || <Translate textKey={'watch_now'} />}
                    </button>
                  </div>}
                  {isDocPlus && showDetails?.button_text && <div
                    className="watchNow"
                    role="button"
                    tabIndex={0}
                    aria-label="Watch Now"
                    onClick={() =>
                      handleWatchNowClick(
                        selectedVideoDetails,
                        showId,
                        setSelectedVideoDetails,
                        showDetails,
                        categories,
                        thumbnailOrientation,
                        appInfo,
                        user,
                        setRefetchTrigger
                      )
                    }
                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleWatchNowClick(selectedVideoDetails, showId, setSelectedVideoDetails, showDetails, categories, thumbnailOrientation, appInfo, user, setRefetchTrigger); } }}
                  >

                    <button
                      style={projectInfo?.projectConfig?.pubid === 50158 ? { color: '#000' } : {
                        color:
                          theme === "LIGHT"
                            ? "white"
                            : (template === "TEMPLATE_9" || template === "TEMPLATE_12")
                              ? buttonTextColor
                              : textColor,
                      }}
                    >
                      {showDetails?.button_text || <Translate textKey={'watch_now'} />}
                    </button>
                  </div>}
                  {isDocPlus && showDetails?.button_rental_text &&
                    <div
                      className={showDetails?.button_text ? "addtoList" : "watchNow"}
                      role="button"
                      tabIndex={0}
                      aria-label="Watch Now"
                      onClick={() => {
                        const checkoutDetails = {
                          rental_checkout_text: showDetails?.rental_checkout_text,
                          rental_checkout_show_name: showDetails?.show_name,
                          rental_checkout_plan_id: showDetails?.rental_checkout_subscription_id,
                          logo: showDetails?.logo_thumb,
                        };
                        const isRental = true;
                        handleWatchNowClick(
                          selectedVideoDetails,
                          showId,
                          setSelectedVideoDetails,
                          showDetails,
                          categories,
                          thumbnailOrientation,
                          appInfo,
                          user,
                          setRefetchTrigger,
                          isRental,
                          checkoutDetails
                        )
                      }

                      }
                      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleWatchNowClick(selectedVideoDetails, showId, setSelectedVideoDetails, showDetails, categories, thumbnailOrientation, appInfo, user, setRefetchTrigger); } }}
                    >
                      <button
                        className="rentalMainText"
                        style={{
                          fontWeight: 600,
                          fontSize: '14px',
                          color:
                            theme === "LIGHT"
                              ? "white"
                              : (template === "TEMPLATE_9" || template === "TEMPLATE_12")
                                ? buttonTextColor
                                : textColor,
                        }}
                      >
                        {showDetails?.button_rental_text}
                      </button>
                      {/* <span className="rentalSubText">{showDetails?.button_rental_sub_text}</span> */}
                    </div>
                  }
                  {showDetails?.watched_percentage > 0 && showDetails?.watched_percentage < 100 && (
                    <div className="watchProgressContainer" onClick={(e) => e.stopPropagation()}>
                      <div className="progressWrapper" aria-hidden="true">
                        <div
                          className="progressLine"
                          style={{
                            width: `${showDetails?.watched_percentage}%`,
                            background: theme === "LIGHT" ? buttonTextColor : undefined,
                          }}
                        />
                      </div>
                    </div>
                  )}

                {showDetails?.watched_percentage > 0 && showDetails?.watched_percentage < 100 && (
                  <div
                    className="addtoList"
                    role="button"
                    tabIndex={0}
                    aria-label="Start over"
                    onClick={(e) => handleStartOver(e, selectedVideoDetails, showDetails, categories, thumbnailOrientation, showId, location?.pathname)}
                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleStartOver(e, selectedVideoDetails, showDetails, categories, thumbnailOrientation, showId, location?.pathname); } }}
                    style={{ marginTop: '12px' }}
                  >
                    { kids ?
                      <button className="startOver"><RefreshIcon /></button>
                      :
                      <button>
                        <Translate textKey={'start_over'} /> ⟳
                      </button>
                    }
                  </div>
                )}
                </>
              )}
              {showDetails?.is_challenge && showDetails?.challenge_joined && (
                <div
                  className="addtoList"
                  onClick={() => leaveChallengeHandler(appInfo, setRefetchTrigger, showDetails?.challenge_id)}
                  onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); leaveChallengeHandler(appInfo, setRefetchTrigger, showDetails?.challenge_id); } }}
                >
                  <button>
                    <Translate textKey={'leave_challenge'} />
                  </button>
                </div>
              )}
              {showDetails?.teaser_flag === 1 && showDetails?.single_video !== 3 &&
                showDetails?.teaser &&
                (template === "TEMPLATE_9" || template === "TEMPLATE_12") && (
                  <div className="trailer" role="button" tabIndex={0} aria-label="Watch Trailer" onClick={() => setIsTrailer(true)} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setIsTrailer(true); } }}>
                    <button><Translate textKey={'trailer'} /></button>
                  </div>
                )}

              {showDetails?.go_ads_free && (
                <div className="addtoList" style={{ marginTop: '10px' }}>
                  <button
                    style={{ width: '100%' }}
                    onClick={() => {
                      if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true") {
                        navigate("/checkout", {
                          state: {
                            showId: showId,
                            is_go_ad_free: true,
                            prevPath: location?.pathname,
                            from: "GoAdFree-detailsScreen"
                          },
                        });
                      } else {
                        navigate("/subscription", {
                          state: {
                            showId: showId,
                            is_go_ad_free: true,
                            prevPath: location?.pathname,
                            from: "GoAdFree-detailsScreen"
                          },
                        });
                      }
                    }}
                  >
                    <Translate textKey={'go_ads_free'} />
                  </button>
                </div>
              )}
              {watchlistStatus === "added" ? (
                <div
                  className="addtoList"
                  role="button"
                  tabIndex={0}
                  aria-label="Remove from my list"
                  onClick={() =>
                    removeFromWatchlist(
                      setWatchlistStatus,
                      appInfo,
                      showId,
                      user
                    )
                  }
                  onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); removeFromWatchlist(setWatchlistStatus, appInfo, showId, user); } }}
                >
                  <button>{kids ? <RemoveFromListIcon2 /> : <Translate textKey={'remove_from_mylist'} />}</button>
                </div>
              ) : (
                <div
                  className="addtoList"
                  role="button"
                  tabIndex={0}
                  aria-label="Add to my list"
                  onClick={() =>
                    addToWatchlist(setWatchlistStatus, appInfo, showId, user)
                  }
                  onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); addToWatchlist(setWatchlistStatus, appInfo, showId, user); } }}
                >
                  <button>{kids ? <AddToListIcon2 /> : <Translate textKey={'add_to_mylist'} />}</button>
                </div>
              )}
              <div className="buttons" role="region" aria-label="Share and Report Buttons">
                <div className="buttonContainerOne">
                  <button
                    className="share"
                    aria-label="Share"
                    onClick={() => {
                      setIsShareActive((prev) => !prev);
                      setIsReport(false);
                    }}
                    ref={shareIconRef}
                  >
                    <Translate textKey={'share'} />
                  </button>
                  <div
                    className={`shareContainer ${isShareActive ? "active" : ""} ${theme === "LIGHT" ? " white-bg" : ""}`}
                    ref={shareRef}
                  >
                    <div
                      className="facebookContainer"
                      onClick={() => setIsShareActive(false)}
                    >
                      <FacebookShareButton
                        url={pageURL}
                        quote={"Share"}
                        className={`facebook ${theme === "LIGHT" ? "light-theme-border" : ""
                          }`}
                      >
                        <Translate textKey={'facebook'} />
                        <div className="icon">
                          <FacebookIcon />
                        </div>
                      </FacebookShareButton>

                    </div>
                    <div
                      className="twitterContainer"
                      onClick={() => setIsShareActive(false)}
                    >
                      <TwitterShareButton url={pageURL} className="twitter">
                        <Translate textKey={'twitter'} />
                        <div className="icon">
                          <TwitterIcon />
                        </div>
                      </TwitterShareButton>
                    </div>
                  </div>
                </div>
                <div className="buttonContainerTwo">
                  <button
                    className="more"
                    aria-label="Report Problem"
                    onClick={() => {
                      setIsReport(!isReport);
                      setIsShareActive(false);
                    }}
                    ref={reportRef}
                  >
                    {isReport ? <Closeicon /> : "..."}
                  </button>
                  {isReport ? (
                    <div
                      className={`reportProblemContainer${isReport ? " active" : ""}${theme === "LIGHT" ? " white-bg" : ""}`}
                      role="button"
                      tabIndex={0}
                      aria-label="Report a problem"
                      onClick={() => navigate("/contact-support")}
                      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate("/contact-support"); } }}
                    >
                      <span><Translate textKey={'report_problem'} /></span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="rightContainer">
            <div className="showMetadata">
              <div className="title-trailer">
                <h1 className="name">
                  {(showDetails?.image_title && imageUrlCheck(showDetails?.image_title)) ? (
                    <img src={showDetails?.image_title} alt="title" />
                  ) : (
                    showDetails?.show_name
                  )}
                </h1>

                {!trailerPlaying &&
                  <div className="watchTrailer"
                    role="button"
                    tabIndex={0}
                    aria-label="Watch Trailer">
                    <button
                      onClick={() => {
                        setTrailerPlaying(true);
                        if (showDetails?.teaser_flag === 1 && showDetails?.single_video !== 3 && showDetails?.teaser) {
                          let trailer = true;
                          let arr = showDetails?.teaser?.split("/").reverse();
                          fetchPlayerToken(
                            trailer,
                            arr[1],
                            appInfo,
                            setPlayerToken,
                            setVideoUrl,
                            showDetails,
                            projectInfo
                          );
                          setNowPlaying("Trailer");
                        }

                        setTimeout(() => {
                          const playerEl = document.querySelector('.videoContainer');
                          if (playerEl) {
                            playerEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
                          }
                        }, 1000);
                        setVideoPlayer(null);
                      }
                      }
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          setTrailerPlaying(true);
                          if (showDetails?.teaser_flag === 1 && showDetails?.single_video !== 3 && showDetails?.teaser) {
                            let trailer = true;
                            let arr = showDetails?.teaser?.split("/").reverse();
                            fetchPlayerToken(
                              trailer,
                              arr[1],
                              appInfo,
                              setPlayerToken,
                              setVideoUrl,
                              showDetails,
                              projectInfo
                            );
                            setNowPlaying("Trailer");
                          }
                          setTimeout(() => {
                            const playerEl = document.querySelector('.videoContainer');
                            if (playerEl) {
                              playerEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }
                          }, 1000);
                          setVideoPlayer(null);
                        }
                      }}
                    >
                      <Translate textKey={'watch_trailer'} />
                    </button>
                  </div>
                }
              </div>

              <div className="data">
                {showDetails?.year && <span className="year">{showDetails?.year}</span>}
                <span className={`duration ${showDetails?.year && "showDot"}  ${/^[A-Za-z0-9\s]+$/.test(showDetails?.duration_text) ? "ltr" : ""}`}>
                  {showDetails?.duration_text}
                </span>
                {showDetails?.rating && (
                  <span className="certificate">{showDetails?.rating}</span>
                )}
                {userRatedCount ? (
                  <div className="userRatings">
                    <div
                      className={
                        userRatedCount >= 1 ? "active star" : "no-active star"
                      }
                    >
                      <StarIcon />
                    </div>
                    <div
                      className={
                        userRatedCount >= 2 ? "active star" : "no-active star"
                      }
                    >
                      <StarIcon />
                    </div>
                    <div
                      className={
                        userRatedCount >= 3 ? "active star" : "no-active star"
                      }
                    >
                      <StarIcon />
                    </div>
                    <div
                      className={
                        userRatedCount >= 4 ? "active star" : "no-active star"
                      }
                    >
                      <StarIcon />
                    </div>
                    <div
                      className={
                        userRatedCount >= 5 ? "active star" : "no-active star"
                      }
                    >
                      <StarIcon />
                    </div>
                  </div>
                ) : (
                  user && (
                    <div
                      className={`addRating ${theme === "LIGHT" ? "light" : ""}`}

                      title={translateText("rate_review")}
                      onClick={() => setRatingReviewModal(true)}
                    >
                      <AddRatings />
                    </div>
                  )
                )}
              </div>
              {showDetails?.sub_text && (
                <div className="data">
                  <span className="subtext">
                    {showDetails?.sub_text}
                  </span>
                </div>
              )}
              <div className="genres" role="region" aria-label="Categories">
                {showDetails?.categories?.map((item, index) => (
                  <span
                    key={index}
                    className={theme === "LIGHT" ? 'white-bg' : ''}
                    role="button"
                    tabIndex={0}
                    aria-label={`View category ${item?.category_name}`}
                    onClick={() =>
                      navigate(`/category/${item?.key}`, {
                        state: { careers: item?.key },
                      })
                    }
                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate(`/category/${item?.key}`, { state: { careers: item?.key } }); } }}
                  >
                    {item?.category_name}
                  </span>
                ))}
              </div>

              {!showDetails?.hide_play_button && (
                <>
                  <div
                    className="watchNow"
                    role="button"
                    tabIndex={0}
                    aria-label="Watch Now"
                    onClick={() =>
                      handleWatchNowClick(
                        selectedVideoDetails,
                        showId,
                        setSelectedVideoDetails,
                        showDetails,
                        categories,
                        thumbnailOrientation,
                        appInfo,
                        user,
                        setRefetchTrigger
                      )
                    }
                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleWatchNowClick(selectedVideoDetails, showId, setSelectedVideoDetails, showDetails, categories, thumbnailOrientation, appInfo, user, setRefetchTrigger); } }}
                  >
                    <button
                      style={projectInfo?.projectConfig?.pubid === 50158 ? { color: '#000' } : {
                        color: theme === "LIGHT" ? "white" :
                          (template === "TEMPLATE_9" || template === "TEMPLATE_12") ? buttonTextColor : textColor,
                      }}
                    >
                      {showDetails?.button_text || <Translate textKey={'watch_now'} />}
                    </button>
                  </div>
                  {isDocPlus && showDetails?.button_rental_text && <div
                    className={showDetails?.button_text ? "addtoList" : "watchNow"}
                    role="button"
                    tabIndex={0}
                    aria-label="Watch Now"
                    onClick={() => {
                      const checkoutDetails = {
                        rental_checkout_text: showDetails?.rental_checkout_text,
                        rental_checkout_show_name: showDetails?.show_name,
                        rental_checkout_plan_id: showDetails?.rental_checkout_subscription_id,
                        logo: showDetails?.logo_thumb,
                      };
                      const isRental = true;
                      handleWatchNowClick(
                        selectedVideoDetails,
                        showId,
                        setSelectedVideoDetails,
                        showDetails,
                        categories,
                        thumbnailOrientation,
                        appInfo,
                        user,
                        setRefetchTrigger,
                        isRental,
                        checkoutDetails
                      )
                    }
                    }
                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleWatchNowClick(selectedVideoDetails, showId, setSelectedVideoDetails, showDetails, categories, thumbnailOrientation, appInfo, user, setRefetchTrigger); } }}
                  >
                    <button
                      style={{
                        fontSize: '14px',
                        fontWeight: 600,
                        // padding: '5px 10px 25px 10px',
                        color: theme === "LIGHT" ? "white" :
                          (template === "TEMPLATE_9" || template === "TEMPLATE_12") ? buttonTextColor : textColor,
                      }}
                    >
                      {showDetails?.button_rental_text || <Translate textKey={'watch_now'} />}
                    </button>
                    {/* <span className="rentalSubText">{showDetails?.button_rental_sub_text}</span> */}
                  </div>}
                  {showDetails?.watched_percentage > 0 && showDetails?.watched_percentage < 100 && (
                    <div className="watchProgressContainer" onClick={(e) => e.stopPropagation()}>
                      <div className="progressWrapper" aria-hidden="true">
                        <div
                          className="progressLine"
                          style={{
                            width: `${showDetails?.watched_percentage}%`,
                            background: theme === "LIGHT" ? buttonTextColor : undefined,
                          }}
                        />
                      </div>
                    </div>
                  )}

                {showDetails?.watched_percentage > 0 && showDetails?.watched_percentage < 100 && (
                  <div
                    className="addtoList"
                    role="button"
                    tabIndex={0}
                    aria-label="Start over"
                    onClick={(e) => handleStartOver(e, selectedVideoDetails, showDetails, categories, thumbnailOrientation, showId, location?.pathname)}
                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleStartOver(e, selectedVideoDetails, showDetails, categories, thumbnailOrientation, showId, location?.pathname); } }}
                    style={{ marginTop: '12px' }}
                  >
                    { kids ?
                      <button className="startOver"><RefreshIcon /></button>
                      :
                      <button>
                        <Translate textKey={'start_over'} /> ⟳
                      </button>
                    }
                  </div>
                )}
                </>
              )}
              {showDetails?.is_challenge && showDetails?.challenge_joined && (
                <div
                  className="addtoList"
                  onClick={() => leaveChallengeHandler(appInfo, setRefetchTrigger, showDetails?.challenge_id)}
                  onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); leaveChallengeHandler(appInfo, setRefetchTrigger, showDetails?.challenge_id); } }}
                >
                  <button
                    style={{
                      color:
                        (template === "TEMPLATE_9" || template === "TEMPLATE_12")
                          ? buttonTextColor
                          : textColor,
                    }}
                  >
                    <Translate textKey={'leave_challenge'} />
                  </button>
                </div>
              )}
              {showDetails?.go_ads_free && (
                <div className="addtoList" style={{ marginTop: '10px' }}>
                  <button
                    style={{ width: '100%' }}
                    onClick={() => {
                      if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true") {
                        navigate("/checkout", {
                          state: {
                            showId: showId,
                            is_go_ad_free: true,
                            prevPath: location?.pathname,
                            from: "GoAdFree-detailsScreen"
                          },
                        });
                      } else {
                        navigate("/subscription", {
                          state: {
                            showId: showId,
                            is_go_ad_free: true,
                            prevPath: location?.pathname,
                            from: "GoAdFree-detailsScreen"
                          },
                        });
                      }
                    }}
                  >
                    <Translate textKey={'go_ads_free'} />
                  </button>
                </div>
              )}
              {showDetails?.teaser_flag === 1 && showDetails?.single_video !== 3 &&
                showDetails?.teaser &&
                (template === "TEMPLATE_9" || template === "TEMPLATE_12") && (
                  <div className="trailer" onClick={() => setIsTrailer(true)}>
                    <button><Translate textKey={'trailer'} /></button>
                  </div>
                )}
              {watchlistStatus === "added" ? (
                <div
                  className="addtoList"
                  onClick={() =>
                    removeFromWatchlist(
                      setWatchlistStatus,
                      appInfo,
                      showId,
                      user
                    )
                  }
                >
                  <button>{kids ? <RemoveFromListIcon2 /> : <Translate textKey={'remove_from_mylist'} />}</button>
                </div>
              ) : (
                <div
                  className="addtoList"
                  onClick={() =>
                    addToWatchlist(setWatchlistStatus, appInfo, showId, user)
                  }
                >
                  <button>{kids ? <AddToListIcon2 /> : <Translate textKey={'add_to_mylist'} />}</button>
                </div>
              )}

              <div className="buttons">
                <div className="buttonContainerOne">
                  <button
                    className="share"
                    onClick={() => {
                      setIsShareActive(!isShareActive);
                      setIsReport(false);
                    }}
                    ref={shareIconTwoRef}
                  >
                    <Translate textKey={'share'} />
                  </button>
                  <div
                    className={
                      isShareActive && theme === "LIGHT"
                        ? "active shareContainer bg-white"
                        : isShareActive
                          ? "active shareContainer"
                          : "shareContainer"
                    }
                    ref={shareTwoRef}
                  >
                    <div
                      className="facebookContainer"
                      onClick={() => setIsShareActive(false)}
                    >
                      <FacebookShareButton
                        url={pageURL}
                        quote={"Share"}
                        className="facebook"
                      >
                        <Translate textKey={'facebook'} />
                        <div className="icon">
                          <FacebookIcon />
                        </div>
                      </FacebookShareButton>
                    </div>
                    <div
                      className="twitterContainer"
                      onClick={() => setIsShareActive(false)}
                    >
                      <TwitterShareButton url={pageURL} className="twitter">
                        <Translate textKey={'twitter'} />
                        <div className="icon">
                          <TwitterIcon />
                        </div>
                      </TwitterShareButton>
                    </div>
                  </div>
                </div>
                <div className="buttonContainerTwo">
                  <button
                    className="more"
                    onClick={() => {
                      setIsReport(!isReport);
                      setIsShareActive(false);
                    }}
                    ref={reportTwoRef}
                  >
                    {isReport ? <Closeicon /> : "..."}
                  </button>
                  {isReport ? (
                    <div
                      className={`reportProblemContainer${isReport ? " active" : ""}${theme === "LIGHT" ? " white-bg" : ""}`}
                      onClick={() => navigate("/contact-support")}
                    >
                      <span><Translate textKey={'report_problem'} /></span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* <p className="description">
                {showDetails?.synopsis || showDetails?.video_description}
              </p> */}
              <p className={`description${isShareActive ? ' hide-on-share-mobile' : ''}`}>
                {isHTML(showDetails?.synopsis || showDetails?.video_description) ? (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: showDetails?.synopsis || showDetails?.video_description,
                    }}
                  />
                ) : (
                  showDetails?.synopsis || showDetails?.video_description
                )}
              </p>
              <div className="info">
                {showDetails?.show_cast && (
                  <div className="starring">
                    <div className="left">
                      <h6><Translate textKey={'starring'} /></h6>
                    </div>
                    <div className="right">
                      <ul className="names">
                        <li>{showDetails?.show_cast}</li>
                      </ul>
                    </div>
                  </div>
                )}
                {showDetails?.director && (
                  <div className="director">
                    <div className="left">
                      <h6><Translate textKey={'directed_by'} /></h6>
                    </div>
                    <div className="right">
                      <h6>{showDetails?.director}</h6>
                    </div>
                  </div>
                )}
              </div>
              {!subscribedUser || selectedVideoDetails?.free_video === true ? (
                (!isDocPlus && showDetails?.subscriptions?.length > 0) ||
                  selectedVideoDetails?.free_video === true ? (
                  <div className="subscriptions" role="region" aria-label="Subscription Options">
                    {!isDocPlus && showDetails?.subscriptions?.map((item, index) => (
                      <div
                        className={`package-item ${theme === 'LIGHT' ? 'light-theme' : ''}`}
                        key={index}
                        role="button"
                        tabIndex={0}
                        aria-label={`Subscribe to ${item?.subscription_text}`}
                        onClick={() => {
                          const checkoutDetails = {
                            rental_checkout_text: item?.subscription_text,
                            rental_checkout_show_name: showDetails?.show_name,
                            rental_checkout_plan_id: item?.subscription_id,
                          };
                          const isRental = true;

                          if (isDocPlus) {
                            handleWatchNowClick(
                              selectedVideoDetails,
                              showId,
                              setSelectedVideoDetails,
                              showDetails,
                              categories,
                              thumbnailOrientation,
                              appInfo,
                              user,
                              setRefetchTrigger,
                              isRental,
                              checkoutDetails
                            )
                          } else {
                            handleSubscribe(
                              item,
                              user,
                              projectInfo,
                              appInfo,
                              showId
                            )
                          }
                        }
                        }
                        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSubscribe(item, user, projectInfo, appInfo, showId); } }}
                      >
                        {item?.subscription_text}
                      </div>
                    ))}
                    {showDetails?.single_video === 1 &&
                      selectedVideoDetails?.free_video === true && (
                        <div
                          className="items free"
                          role="button"
                          tabIndex={0}
                          aria-label="Watch for free"
                          onClick={() =>
                            watchVideoHandler(
                              selectedVideoDetails,
                              showId,
                              setSelectedVideoDetails,
                              showDetails,
                              categories,
                              thumbnailOrientation
                            )
                          }
                          onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); watchVideoHandler(selectedVideoDetails, showId, setSelectedVideoDetails, showDetails, categories, thumbnailOrientation); } }}
                        >
                          <Translate textKey={'free'} />
                        </div>
                      )}
                  </div>
                ) : null
              ) : null}
            </div>
            {/* {showDetails?.categories?.length > 0 && (
                <CategoriesSection showDetails={showDetails} scrollDownRef={scrollDownRef} />
            )} */}
            {kids && isMobile && showDetails?.single_video === 0 && (
              <div className="mobileTabs">
                <button
                  className={visibleSection === "episodes" ? "active" : ""}
                  onClick={() => setVisibleSection("episodes")}
                >
                  <Translate textKey={'episodes'} />
                </button>
                <button
                  className={visibleSection === "related" ? "active" : ""}
                  onClick={() => setVisibleSection("related")}
                >
                  <Translate textKey={'you_may_also_like'} />
                </button>
              </div>
            )}

            {(!kids || !isMobile || visibleSection === "episodes") && showDetails?.single_video === 0 && showDetails?.videos?.length > 0 && showDetails?.videos[0]?.videos ? (
              kids ? (
                <GaiaShowsRow
                  season={true}
                  data={showDetails?.videos}
                  metaData={false}
                  watchVideoHandler={watchVideoHandler}
                  type="Episode"
                  forceThumbnailOrientation={template === "TEMPLATE_12" ? "LANDSCAPE" : undefined}
                  vanityUrl={showDetails?.vanity_url}
                  showname={showDetails?.show_name}
                  showDetailsData={showDetails}
                  setSelectedVideoDetails={setSelectedVideoDetails}
                  categories={showDetails?.categories}
                />
              ) : (
                <ShowsRow
                  season={true}
                  data={showDetails?.videos}
                  metaData={false}
                  watchVideoHandler={watchVideoHandler}
                  type="Episode"
                  vanityUrl={showDetails?.vanity_url}
                  showname={showDetails?.show_name}
                  showDetailsData={showDetails}
                  setSelectedVideoDetails={setSelectedVideoDetails}
                  categories={showDetails?.categories}
                />
              )
            ) : (!kids || !isMobile || visibleSection === "episodes") && showDetails?.single_video === 0 && showDetails?.videos?.length === 1 && showDetails?.videos[0]?.season ? (
              kids ? (
                <GaiaShowsRow
                  season={false}
                  data={showDetails?.videos[0]?.videos}
                  title={<Translate textKey={'episodes'} />}
                  metaData={false}
                  watchVideoHandler={watchVideoHandler}
                  type="Episode"
                  forceThumbnailOrientation={template === "TEMPLATE_12" ? "LANDSCAPE" : undefined}
                  vanityUrl={showDetails?.vanity_url}
                  showname={showDetails?.show_name}
                  showDetailsData={showDetails}
                  setSelectedVideoDetails={setSelectedVideoDetails}
                  categories={showDetails?.categories}
                />
              ) : (
                <ShowsRow
                  season={false}
                  data={showDetails?.videos[0]?.videos}
                  title={<Translate textKey={'episodes'} />}
                  metaData={false}
                  watchVideoHandler={watchVideoHandler}
                  type="Episode"
                  vanityUrl={showDetails?.vanity_url}
                  showname={showDetails?.show_name}
                  showDetailsData={showDetails}
                  setSelectedVideoDetails={setSelectedVideoDetails}
                  categories={showDetails?.categories}
                />
              )
            ) : (!kids || !isMobile || visibleSection === "episodes") && showDetails?.single_video === 0 && !showDetails?.videos[0]?.videos ? (
              kids ? (
                <GaiaShowsRow
                  season={false}
                  data={showDetails?.videos}
                  title={<Translate textKey={'episodes'} />}
                  metaData={false}
                  watchVideoHandler={watchVideoHandler}
                  type="Episode"
                  forceThumbnailOrientation={template === "TEMPLATE_12" ? "LANDSCAPE" : undefined}
                  vanityUrl={showDetails?.vanity_url}
                  showname={showDetails?.show_name}
                  showDetailsData={showDetails}
                  setSelectedVideoDetails={setSelectedVideoDetails}
                  categories={showDetails?.categories}
                />
              ) : (
                <ShowsRow
                  season={false}
                  data={showDetails?.videos}
                  title={<Translate textKey={'episodes'} />}
                  metaData={false}
                  watchVideoHandler={watchVideoHandler}
                  type="Episode"
                  vanityUrl={showDetails?.vanity_url}
                  showname={showDetails?.show_name}
                  showDetailsData={showDetails}
                  setSelectedVideoDetails={setSelectedVideoDetails}
                  categories={showDetails?.categories}
                />
              )
            ) : null}
            {(showDetails?.single_video === 2 &&
              showDetails?.videos?.length > 0 &&
              showDetails?.videos[0]?.videos) ? (
              showDetails.videos.map((season, idx) => (
                <ShowsRow
                  key={season.season_id || idx}
                  season={false}
                  data={season.videos}
                  metaData={false}
                  watchVideoHandler={watchVideoHandler}
                  type="Episode"
                  title={season.season}
                  vanityUrl={showDetails?.vanity_url}
                  showname={showDetails?.show_name}
                  showDetailsData={showDetails}
                  setSelectedVideoDetails={setSelectedVideoDetails}
                  categories={showDetails?.categories}
                  showId={showId}
                  isChallenge={showDetails?.is_challenge}
                />
              ))
            ) : (showDetails?.single_video === 2 &&
              showDetails?.videos?.length > 1 && (
                <ShowsRow
                  season={false}
                  data={showDetails?.videos}
                  metaData={false}
                  watchVideoHandler={watchVideoHandler}
                  type="Episode"
                  vanityUrl={showDetails?.vanity_url}
                  showname={showDetails?.show_name}
                  showDetailsData={showDetails}
                  setSelectedVideoDetails={setSelectedVideoDetails}
                  categories={showDetails?.categories}
                  showId={showId}
                  isChallenge={showDetails?.is_challenge}
                />
              ))}
            {showDetails?.single_video === 3 && showDetails?.videos && (
              <div className="verticalEpisodeBoxes">
                <div className="episodesHeader">
                  <h3><Translate textKey={'episodes'} /></h3>
                  {showDetails.videos.length > 30 && (
                    <button
                      className="showMoreBtn headerShowMore"
                      onClick={() => setShowAllEpisodes(prev => !prev)}
                    >
                      <span className="showMoreText">{showAllEpisodes ? <Translate textKey={'show_less'} /> : <Translate textKey={'show_more'} />}</span>
                      <ChevronDown className={showAllEpisodes ? 'chev up' : 'chev'} />
                    </button>
                  )}
                </div>
                <div className="episodesContainer">
                  <div className="episodesGrid">
                    {(() => {
                      const episodesList = showDetails.videos || [];
                      const rowsToShow = 3;
                      const limit = episodesColumns * rowsToShow;
                      const visibleCount = showAllEpisodes ? episodesList.length : Math.min(limit, episodesList.length);
                      return episodesList.slice(0, visibleCount).map((episode, idx) => {
                        const actualIndex = idx;
                        const hasThumb = !!episode.thumbnail;
                        const subscribedLock = episode.is_locked === true;
                        const episodeIdentifier = episode?.vanity_url || episode?.video_id;
                        return (
                          <div
                            key={episode.video_id || idx}
                            className={`episodeItem ${hasThumb ? 'hasThumb' : ''}`}
                            onClick={() => navigate(`/vertical-show/${showDetails?.vanity_url || showDetails?.show_id}${episodeIdentifier ? `/${episodeIdentifier}` : ''}`, { state: { episodeId: episode.video_id, episodeVanity: episodeIdentifier, prevPath: location?.pathname } })}
                            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate(`/vertical-show/${showDetails?.vanity_url || showDetails?.show_id}${episodeIdentifier ? `/${episodeIdentifier}` : ''}`, { state: { episodeId: episode.video_id, episodeVanity: episodeIdentifier, prevPath: location?.pathname } }); } }}
                            role="button"
                            tabIndex={0}
                          >
                            <span className="episodeBoxTitle">{episode?.video_title}</span>
                            {subscribedLock && (
                              <div className="episodeLock">
                                <img src={LockIcon} alt="locked" style={{ width: '12px', height: '12px' }} />
                              </div>
                            )}
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
              </div>
            )}
            {showDetails?.key_art_work?.length > 0 && <AboutSection showDetails={showDetails} />}

            {showDetails?.awards?.length > 0 && <AwardsAndFestivals showDetails={showDetails} />}

            {showDetails?.cast?.length > 0 && (
              showDetails?.cast?.some(item => item?.image) ? (
                <CastAndCrew type="Cast" data={showDetails?.cast} />
              ) : (
                <div className="metaItem">
                  <h6 className="subHeading"><Translate textKey={'cast'} /></h6>
                  <div className="items">
                    {showDetails?.cast?.map((item) => (
                      <div className="item" key={item?.id}>
                        <span
                          className="itemInfo"
                          onClick={() => searchHandler(item?.name, "cast")}
                        >
                          {item?.name}
                        </span>
                        <span className="itemLabel">{item?.role}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}

            {showDetails?.crew?.length > 0 && (
              showDetails?.crew?.some(item => item?.image) ? (
                <CastAndCrew type="Crew" data={showDetails?.crew} />
              ) : (
                showDetails?.crew?.length > 0 && (
                  <div className="metaItem">
                    <h6 className="subHeading"><Translate textKey={'crew'} /></h6>
                    <div className="items">
                      {showDetails?.crew?.map((item) => (
                        <div className="item" key={item?.id}>
                          <span
                            className="itemInfo"
                            onClick={() => searchHandler(item?.name, "crew")}
                          >
                            {item?.name}
                          </span>
                          <span className="itemLabel">{item?.role}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )
              )
            )}


            {(!kids || !isMobile || showDetails?.single_video !== 0 || visibleSection === "related") && similarVideos?.length > 0 && (
              kids && isMobile && (showDetails?.single_video === 0 || showDetails?.single_video === 1) ? (
                <GaiaShowsRow
                  season={false}
                  data={similarVideos}
                  title={<Translate textKey={'you_may_also_like'} />}
                  metaData={true}
                  setVideoPlayer={setVideoPlayer}
                  similarVideos={true}
                  showId={showId}
                />
              ) : (
                <ShowsRow
                  season={false}
                  data={similarVideos}
                  title={<Translate textKey={'you_may_also_like'} />}
                  metaData={true}
                  setVideoPlayer={setVideoPlayer}
                  similarVideos={true}
                  vanityUrl={showDetails?.vanity_url}
                />
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsScreen;
